<template>
  <div>
    <el-header style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header> 

    <el-main>
    <Table :tableData.sync="tableData" :showSearch="true" :showEdit="true" :showExport="true" :showImport="true" :showEditButton="true"  
          @sync-delete="deleteData" @sync-save="saveData" @reload-data-by-sort="reloadDataBySort"/> 
    </el-main>
  </div>
</template>

<script>
import Breadcrumb from "../components/Breadcrumb.vue";
import Table from '../components/EditableTable'
import { apiFindVersionMapping, apiSaveVersionMapping, apiDeleteVersionMappingById } from "../../utils/api.js";
import authHeader from "../../services/auth-header";

export default {
  name: 'firmwareVersionMapping',
  data() {
    return {
      tableData: {
        sel: null,
        columns: [
          { field: "type", title: "type", type:"select", width: 150, required:true,selectObj: [{value:'Beta ver.', label:'Beta ver.'},{value:'Formal ver.', label:'Formal ver.'}]},
          { field: "releaseDate", title: "releaseDate", type:"date",  width: 170 , required:true },
          { field: "model", title: "model", width: 230, required:true  },
          { field: "modelName", title: "modelName", width: 230, required:true  },
          { field: "productId", title: "productId", width: 230, required:true  },
          { field: "fwVersion", title: "fwVersion", width: 230, required:true  },
          { field: "remark", title: "remark", width: 230  }
        ],
        typeOpt:[{value:'Beta ver.', label:'Beta ver.'},{value:'Formal ver.', label:'Formal ver.'}],
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'dataTable',
        exportName: 'Firmware_Version_Mapping'
      },
      sortColumn:'',
      sortType:'',
    };
  },
  components: {
    Breadcrumb,
    Table
  },
  mounted() {    
    this.readData();
  },
  methods: {
    readData(){
      this.tableData.data = [];
      this.tableData.originalTableData =  [];  
      apiFindVersionMapping({ headers: authHeader(), sortColumn:this.sortColumn, sortType:this.sortType }).then((response) => {               
        this.tableData.data = response.data;
        this.tableData.originalTableData =  this.tableData.data;    
      }).catch((err) => {
        console.log(err);
      });
    },
    saveData(data){
 
      if(data.length == null){
        data = [data];
      }
      
      apiSaveVersionMapping({  headers: authHeader(), versions : data}).then((response) => {                    
        if(response.status == 200){
          this.readData();
          this.$message.success({message: this.$i18n.t('msg.saveSuccess'), duration: 800});
        }else{          
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        }           
      
      }).catch((err) => {
        if(err.response.data.message != null && err.response.data.message != ''){
          this.$message.error({message:err.response.data.message, duration: 1000});
        }else{
          this.$message.error({message: this.$i18n.t('msg.saveFail'), duration: 1000});
        }        
        console.log(err);
      });
    },
    deleteData(data){           
      apiDeleteVersionMappingById({  headers: authHeader(), deleteId : data.id}).then((response) => {               
        if(response.status == 200){
          this.$message.success({message: this.$i18n.t('msg.deleteSuccess'), duration: 800});
        }else{
          this.$message.error({message: this.$i18n.t('msg.deleteFail'), duration: 800});
        }
      }).catch((err) => {
        console.log(err);
      });
    },
    reloadDataBySort(sortColumn, sortType){
      this.sortColumn = sortColumn;
      this.sortType = sortType;
      this.readData()
    } 
  }
};
</script>